module.exports = __FOREMAN_VENDOR__UNIDIFF__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__UNIDIFF__"
// module id = unidiff
// module chunks = 32